import React, { useEffect, useState } from 'react';
import { Grid, View, Flex, ProgressCircle } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';

import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import TaskColumn from '../../components/tasks/TaskColumn';

import { MyTask } from './workfrontTaskStyle';

const WorkfrontTasks = props => {
  const [backlogState, setBacklogState] = useState({
    isLoading: true,
    elements: [],
  });
  const [ongoingState, setOngoingState] = useState({
    isLoading: true,
    elements: [],
  });
  const [completedState, setCompletedState] = useState({
    isLoading: true,
    elements: [],
  });
  const [isLoading, setLoading] = useState(true);
  const { user } = props;

  async function getTasks() {
    const fields = [
      'ID',
      'name',
      'description',
      'objCode',
      'percentComplete',
      'plannedCompletionDate',
      'plannedStartDate',
      'priority',
      'status',
      'taskNumber',
      'project:status',
      'project:program',
      'project:portfolio',
      'assignmentsListString',
      'assignments:assignedTo',
    ];
    const queryParams = {
      'assignments:assignedToID': user,
      parentID_Mod: 'notblank',
      'project:status': 'CUR',
    };
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK_SEARCH, queryParams, fields },
    );
    if (actionResponse.error) {
      setBacklogState({
        ...backlogState,
        isLoading: false,
      });
      setOngoingState({
        ...ongoingState,
        isLoading: false,
      });
      setCompletedState({
        ...completedState,
        isLoading: false,
      });
    }
    setBacklogState({
      ...backlogState,
      backlogTasks: actionResponse.filter(task => task.status === 'NEW'),
      isLoading: false,
    });
    setOngoingState({
      ...ongoingState,
      ongoingTasks: actionResponse.filter(task => task.status === 'INP'),
      isLoading: false,
    });
    setCompletedState({
      ...completedState,
      completedTasks: actionResponse.filter(task => task.status === 'CPL'),
      isLoading: false,
    });
  }

  useEffect(() => {
    if (user.length > 0) {
      getTasks();
    }
  }, [user]);

  useEffect(() => {
    if (
      !backlogState.isLoading ||
      !ongoingState.isLoading ||
      !completedState.isLoading
    ) {
      setLoading(false);
    }
  }, [backlogState, ongoingState, completedState]);

  return (
    <View
      backgroundColor="gray-50"
      padding="size-300"
      paddingBottom="size-0"
      marginTop="size-250"
      marginBottom="size-250"
      columns={['calc(100% - size-5000)']}
    >
      <MyTask>My Tasks</MyTask>
      {isLoading ? (
        <Flex justifyContent="space-around">
          <ProgressCircle
            size="L"
            aria-label="Loading…"
            marginTop="size-3000"
            marginBottom="size-4600"
            isIndeterminate
          />
        </Flex>
      ) : (
        <Grid
          margin="size-400"
          areas={['backlog ongoing completed']}
          columns={['3fr', '3fr', '3fr']}
          gap="size-175"
        >
          <TaskColumn
            type="backlog"
            title="Backlog"
            items={backlogState.backlogTasks}
          />
          <TaskColumn
            type="ongoing"
            title="In-Progress"
            items={ongoingState.ongoingTasks}
          />
          <TaskColumn
            type="completed"
            title="In-Review"
            items={completedState.completedTasks}
          />
        </Grid>
      )}
    </View>
  );
};

WorkfrontTasks.propTypes = {
  user: PropTypes.string,
};
WorkfrontTasks.defaultProps = {
  user: '',
};

export default WorkfrontTasks;
